







import ComponentDoc from '@components/ComponentDoc.vue'

export default
  components:
    'component-doc': ComponentDoc
  props:
    docObjects:
      type: Array
      required: true



// WEBPACK FOOTER //
// ./node_modules/coffeelint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pug-lint-loader?{"disallowBlockExpansion":null,"disallowClassAttributeWithStaticValue":true,"disallowClassLiterals":null,"disallowClassLiteralsBeforeAttributes":null,"disallowClassLiteralsBeforeIdLiterals":true,"disallowDuplicateAttributes":true,"disallowHtmlText":true,"disallowIdAttributeWithStaticValue":true,"disallowIdLiterals":null,"disallowIdLiteralsBeforeAttributes":true,"disallowMultipleLineBreaks":true,"disallowSpacesInsideAttributeBrackets":true,"disallowSpecificAttributes":null,"disallowSpecificTags":["b","i"],"disallowStringConcatenation":true,"disallowStringInterpolation":true,"disallowTagInterpolation":true,"disallowTemplateString":true,"disallowTrailingSpaces":true,"maximumLineLength":180,"maximumNumberOfLines":80,"requireClassLiteralsBeforeAttributes":null,"requireClassLiteralsBeforeIdLiterals":null,"requireIdLiteralsBeforeAttributes":null,"requireLineFeedAtFileEnd":true,"requireLowerCaseAttributes":true,"requireLowerCaseTags":true,"requireSpacesInsideAttributeBrackets":null,"requireSpecificAttributes":null,"requireStrictEqualityOperators":true,"validateAttributeQuoteMarks":null,"validateAttributeSeparator":{"separator":", ","multiLineSeparator":",/n  "},"validateDivTags":true,"validateLineBreaks":"LF"}!./src/pages/Top/ComponentDocs.vue